import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { UserIdentity } from '@/types';
import { identityService } from '@/services/identityService';

interface IdentityState {
  identities: UserIdentity[];
  loading: boolean;
  
  // Actions
  loadIdentities: () => Promise<void>;
  addIdentity: (statement: string, pillar?: string) => Promise<void>;
  updateIdentity: (id: string, updates: { identityStatement?: string; pillar?: string }) => Promise<void>;
  deleteIdentity: (id: string) => Promise<void>;
  getIdentityForHabit: (habitId: string) => UserIdentity | null;
  incrementVotes: (identityId: string) => void;
}

export const useIdentityStore = create<IdentityState>()(
  persist(
    (set, get) => ({
      identities: [],
      loading: false,

      loadIdentities: async () => {
        set({ loading: true });
        try {
          const identities = await identityService.getUserIdentities();
          set({ identities, loading: false });
        } catch (error) {
          console.error('Erro ao carregar identidades:', error);
          set({ loading: false });
        }
      },

      addIdentity: async (statement, pillar) => {
        try {
          const id = await identityService.createIdentity(statement, pillar);
          const newIdentity: UserIdentity = {
            id,
            userId: '', // será populado no reload
            identityStatement: statement,
            pillar: pillar as any,
            votesCast: 0,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          };
          set(state => ({ identities: [...state.identities, newIdentity] }));
          // Reload para pegar dados completos
          await get().loadIdentities();
        } catch (error) {
          console.error('Erro ao adicionar identidade:', error);
          throw error;
        }
      },

      updateIdentity: async (id, updates) => {
        try {
          await identityService.updateIdentity(id, updates);
          set(state => ({
            identities: state.identities.map(i =>
              i.id === id ? { ...i, ...updates as any, updatedAt: new Date().toISOString() } : i
            )
          }));
        } catch (error) {
          console.error('Erro ao atualizar identidade:', error);
          throw error;
        }
      },

      deleteIdentity: async (id) => {
        try {
          await identityService.deleteIdentity(id);
          set(state => ({
            identities: state.identities.filter(i => i.id !== id)
          }));
        } catch (error) {
          console.error('Erro ao deletar identidade:', error);
          throw error;
        }
      },

      getIdentityForHabit: (habitId) => {
        // TODO: Implementar lógica quando hábitos tiverem identity_vote_target
        return null;
      },

      incrementVotes: (identityId) => {
        set(state => ({
          identities: state.identities.map(i =>
            i.id === identityId ? { ...i, votesCast: i.votesCast + 1 } : i
          )
        }));
      }
    }),
    {
      name: 'identity-store'
    }
  )
);
